module.exports = __webpack_public_path__ + "img/1535983549.f63f0a25.jpg";